/**
 * The Cornerstone Education mark: a line-drawn schoolhouse.
 *
 * Inline SVG rather than an image file so it inherits `currentColor` and works
 * on both the white login panel and the dark navigation bar without shipping
 * two assets or a filter hack.
 */

export function SchoolMark({ className }: { className?: string }) {
  const stroke = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }

  return (
    <svg className={className} viewBox="0 0 120 84" role="img" aria-label="Cornerstone Education">
      {/* Flagpole */}
      <path d="M60 6v9" {...stroke} />
      <path d="M60 6.5h7l-2.2 3 2.2 3H60z" fill="currentColor" stroke="none" />

      {/* Cupola */}
      <path d="M54 29v-6l6-8 6 8v6" {...stroke} />
      <path d="M57.5 29v-4.5h5V29" {...stroke} />

      {/* Main roofline and body */}
      <path d="M26 40l34-13 34 13" {...stroke} />
      <path d="M31 40v30h58V40" {...stroke} />

      {/* Portico */}
      <path d="M50 70V52h20v18" {...stroke} />
      <path d="M53.5 52v18M60 52v18M66.5 52v18" {...stroke} strokeWidth={1.1} />

      {/* Windows */}
      <rect x="37" y="47" width="7" height="8" rx="1" {...stroke} strokeWidth={1.1} />
      <rect x="76" y="47" width="7" height="8" rx="1" {...stroke} strokeWidth={1.1} />
      <rect x="37" y="59" width="7" height="8" rx="1" {...stroke} strokeWidth={1.1} />
      <rect x="76" y="59" width="7" height="8" rx="1" {...stroke} strokeWidth={1.1} />

      {/* Ground */}
      <path d="M18 70h84" {...stroke} />

      {/* Trees, which the approved mark carries on both flanks */}
      <path d="M14 70V58M14 58l-5 6h10z M14 62l-6 7h12z" {...stroke} strokeWidth={1.2} />
      <path d="M106 70V58M106 58l-5 6h10z M106 62l-6 7h12z" {...stroke} strokeWidth={1.2} />
    </svg>
  )
}

/** The compact mark used in the navigation bar, where height is 28px. */
export function SchoolMarkCompact({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" role="img" aria-label="Cornerstone Education">
      <path
        d="M16 4l13 6-13 6-13-6z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M8 13.8V21c0 2.2 3.6 4 8 4s8-1.8 8-4v-7.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M29 10v6.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
